import { useEffect } from 'react';
import { FormikProps } from 'formik';
import { useRouterHelper, useTranslation } from '@shared/core';
import { useContactCollectorGuestTelemetry } from '../../ContactCollectorGuest.telemetry';
import { withWindow } from '@shared/utils/withWindow';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import { contactCollectorGuestRoutePaths } from '../..';
import type { Contacts } from '../../shared/types';

export const useDoneController = (formik: FormikProps<Contacts>, website: string) => {
  const isMobile = useIsMobileScreen();
  const routeHelpers = useRouterHelper();
  const { buttonInteracted } = useContactCollectorGuestTelemetry();
  const { t } = useTranslation('contactCollector');
  const tAdmin = t('admin');

  useEffect(() => {
    if (!formik.isValid) routeHelpers.goToExactRoute(contactCollectorGuestRoutePaths.landing.path);
  }, [formik.isValid, routeHelpers]);

  const handleOnVisitEventWebsiteClick = () => {
    buttonInteracted({ buttonType: 'navigation', element: 'visitEventWebsite' });
    withWindow(() => {
      window.open(`${window.location.origin}/${website}`, '_blank');
    });
  };

  return {
    tAdmin,
    handleOnVisitEventWebsiteClick,
    isMobile,
  };
};
